var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-ui-table-tr',_vm._b({staticClass:"bg-dark-800 text-white"},'v-ui-table-tr',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }